import React from 'react';
import ReactDOM from 'react-dom';
import { sortBy, find, isEmpty, result } from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PopupContextProvider } from '@bingads-webui-react/popup-manager';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { stringifySync } from '@bingads-webui/safe-json';
import { getWebuiSurveyList } from './survey-list';
import { SurveyContainer } from './survey-container';
import { createDOMContainer } from './util';

let lastActiveElement;

export const SurveyManager = (props) => {
  const {
    i18n,
    serverContext,
    PreferenceService,
    tokenInfo,
    appActivity,
    activityName,
    appPerfMarker,
  } = props;

  const logActivity = (message) => {
    if (appActivity) {
      appActivity.signal(message, activityName);
    }
  };

  const {
    surveyList = getWebuiSurveyList({
      serverContext,
      PreferenceService,
      logActivity,
    }),
  } = props;

  const isTestEnv = !result(serverContext, 'IsProdEnv') && !window.location.href.toLowerCase().includes('ads.microsoft.com');

  const isTokenInfoInvalid = () => !isTestEnv &&
    (isEmpty(tokenInfo) || !tokenInfo.UserId || !tokenInfo.TenantId);

  const renderSurveyToDom = (survey) => {
    if (isTokenInfoInvalid()) {
      logActivity(`SurveyManager | tokenInfo is invalid, tokenInfo: ${tokenInfo}`);
      return;
    }

    const renderSurveyPerfMarker = appPerfMarker.createChild('Render_Survey');
    renderSurveyPerfMarker.willInit();
    lastActiveElement = document && document.activeElement;
    ReactDOM.render(
      <I18nContext.Provider value={i18n}>
        <ServerContext.Provider value={serverContext}>
          {/* enable centralized popup management for survey */}
          <PopupContextProvider>
            <SurveyContainer
              survey={survey}
              logActivity={logActivity}
              isTestEnv={isTestEnv}
              onSurveyRender={(additionalLogData = {}) => {
                survey.onSurveyRender();
                logActivity(`SurveyManager | survey: ${survey.getSurveyName()}, action: render, additionalLogData: ${stringifySync(additionalLogData)}`);
                renderSurveyPerfMarker.done();
              }}
              lastActiveElement={lastActiveElement}
              resetActiveElement={() => {
                lastActiveElement = undefined;
              }}
              {...props}
            />
          </PopupContextProvider>
        </ServerContext.Provider>
      </I18nContext.Provider>,
      createDOMContainer()
    );
  };

  const selectSurvey = () => {
    // get the available survey with the highest priority
    const sortedSurveyList = sortBy(surveyList, survey => survey.getSurveyPriority()).reverse();
    const selectedSurvey = find(sortedSurveyList, survey =>
      survey.validateTriggerCondition() && survey.validateUserGovernance());

    return selectedSurvey;
  };

  let survey;

  return {
    getSurvey: () => survey,
    setSurvey: () => {
      survey = selectSurvey();
    },
    render: () => {
      if (survey) {
        renderSurveyToDom(survey);
      }
    },
    trigger: ({
      checkIfSurveyIsOpen,
    } = {}) => {
      if (checkIfSurveyIsOpen) {
        const elements = document.getElementsByClassName('webui-user-survey');
        if (elements.length) {
          return;
        }
      }
      const newSurvey = selectSurvey();
      if (!newSurvey) {
        // do nothing if no available survey
      } else {
        survey = newSurvey;
        renderSurveyToDom(survey);
      }
    },
  };
};
